import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';

import {
  NavBar,
  Heading,
  FilterList,
  Modal,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  ButtonIconContextual,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import SingleSliderFilter from '../SingleSliderFilter/SingleSliderFilter.vue';
import DoubleSliderFilter from '../DoubleSliderFilter/DoubleSliderFilter.vue';

interface IFilter {
  label: string;
  isMultiple: boolean;
  value: string;
  selectedFilters: string | string[] | number;
  options: { label: string; value: string }[];
  details?: { title: string; description: string }[];
}

interface EmitEvents {
  (event: 'apply-filters', filters: IFilter[], count: number): void;
  (event: 'close'): void;
}
interface Props {
  isOpen: boolean;
  filters: IFilter[];
  clear?: boolean;
}
interface IDescriptionModal {
  label: string;
  details: { title: string; description: string }[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarFilters',
  props: {
    isOpen: { type: Boolean },
    filters: null,
    clear: { type: Boolean, default: false }
  },
  emits: ["apply-filters", "close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'apply-filters', filters: IFilter[], count: number): void;
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOpen: boolean, filters: IFilter[], clear: boolean };





const isDescriptionModalOpen = ref(false);

const selectedFilterDetails = ref<IDescriptionModal | null>({
  label: '',
  details: []
});

const isSecondaryMarketEnabled = computed(() =>
  FeatureFlagsModule.isEnabled(FeatureFlags.ENABLE_SECONDARY_MARKET)
);

function handleSingleSliderChange(value: number, index: number) {
  filtersData.value[index].selectedFilters = String(value);
}

function handleDoubleSliderChange(
  payload: { left: number; right: number },
  index: number
) {
  const leftValue = payload.left === undefined ? '' : String(payload.left);
  const rightValue = payload.right === undefined ? '' : String(payload.right);

  filtersData.value[index].selectedFilters = [leftValue, rightValue];
}

function handleChange(value: string, index: number, filter: IFilter) {
  if (filter.isMultiple) {
    filtersData.value[index].selectedFilters = value;
  } else if (filtersData.value[index].selectedFilters === value) {
    filtersData.value[index].selectedFilters = '';
  } else filtersData.value[index].selectedFilters = value;
}

function openDescriptionModal(
  label: string,
  details: { title: string; description: string }[]
) {
  isDescriptionModalOpen.value = true;
  selectedFilterDetails.value = { label, details };
}

watch(
  () => props.clear,
  clear => {
    if (clear) {
      clearFilters();
    }
  },
  { immediate: true }
);

const filtersData = ref<IFilter[]>([]);

const filterCount = computed(() => {
  let count = 0;

  filtersData.value.forEach(filter => {
    if (
      filter.value === 'minimumInvestment' &&
      Number(filter.selectedFilters) === 0
    )
      return;
    if (!filter.isMultiple && filter.selectedFilters) count += 1;
    else count += filter.selectedFilters.length;
  });

  return count;
});

const getSliderValue = (
  value: string | number | string[]
): number | undefined => {
  if (typeof value !== 'string' || value === '') {
    return undefined;
  }

  const num = Number(value);
  return isNaN(num) ? undefined : num;
};

function handleFilters() {
  const appliedFilters: IFilter[] = [];
  const filtersToEmit: IFilter[] = [];
  filtersData.value.forEach(filter => {
    if (filter.value === 'minimumInvestment') {
      if (Number(filter.selectedFilters) > 0) {
        appliedFilters.push(filter);
        filtersToEmit.push(filter);
      }
      return;
    }

    if (filter.value === 'maturityDate') {
      const selected = filter.selectedFilters;

      if (Array.isArray(selected) && selected.length === 2) {
        appliedFilters.push(filter);
        filtersToEmit.push(
          {
            ...filter,
            value: 'minimumMaturity',
            selectedFilters: selected[0],
            isMultiple: false,
            options: []
          },
          {
            ...filter,
            value: 'maximumMaturity',
            selectedFilters: selected[1],
            isMultiple: false,
            options: []
          }
        );
      }
      return;
    }

    if (Array.isArray(filter.selectedFilters)) {
      if (filter.selectedFilters.length > 0) {
        appliedFilters.push(filter);
        filtersToEmit.push(filter);
      }
    } else if (String(filter.selectedFilters).length > 0) {
      appliedFilters.push(filter);
      filtersToEmit.push(filter);
    }
  });

  emit('apply-filters', filtersToEmit, filterCount.value);
}

function clearFilters() {
  filtersData.value = filtersData.value.map(filter => {
    return {
      ...filter,
      selectedFilters: filter.isMultiple ? [] : ''
    };
  });

  handleFilters();
}

onMounted(() => {
  filtersData.value = props.filters;
});

return { __sfc: true,emit, props, isDescriptionModalOpen, selectedFilterDetails, isSecondaryMarketEnabled, handleSingleSliderChange, handleDoubleSliderChange, handleChange, openDescriptionModal, filtersData, filterCount, getSliderValue, handleFilters, clearFilters, NavBar, Heading, FilterList, Modal, ButtonContainer, ButtonPrimary, ButtonSecondary, ButtonIconContextual, BaseText, SideSheet, BackButton, SingleSliderFilter, DoubleSliderFilter }
}

})